<div class="company-photo-id-container">
  <span class="company-photo-id-container__header">
    {{ "LABELS.PHOTO_ID" | translate }}

    <span class="d-lg-none">
      <app-hint-tooltip-icon [hint]="'LABELS.PHOTO_ID_DESCRIPTION' | translate"></app-hint-tooltip-icon>
    </span>
  </span>
  <div class="d-flex">
    <div class="col-12 col-lg-8 pl-0 pr-0">
      <document-upload-image
        [downloadLink]="photoIdUri"
        [isLoading]="isLoading"
        [isShowLoader]="!!companyId"
        [headerLabel]="'LABELS.PHOTO_ID'"
        [badgeLabel]="'LABELS.REQUIRED'"
        [badgeClass]="'required-badge'"
        [descriptionHint]="'COMPANY.UPLOAD_PHOTO_ID_HINT'"
        [uploadedFileLabel]="'LABELS.PHOTO_ID'"
        [showRemoveButton]="false"
        [isNonImageDocument]="isNonImageDocument"
        [fileName]="fileName"
        (upload)="uploadPhotoId($event)"
      ></document-upload-image>
    </div>

    <div class="d-none d-lg-block col-4">
      <div class="company-photo-id-container__description">
        <span>{{ "LABELS.PHOTO_ID_DESCRIPTION" | translate }}</span>
      </div>
    </div>
  </div>
</div>
